export const SECURITY_QUESTIONS = [
  "What was the name of your first pet?",
  "What city were you born in?",
  "What is your mother's maiden name?",
  "What was the make of your first car?",
  "What elementary school did you attend?",
  "What is the name of your childhood best friend?",
  "What street did you grow up on?",
  "What is your oldest sibling's middle name?",
  "What was the name of your first employer?",
  "What is the middle name of your oldest child?",
];
